export default __webpack_public_path__ + "static/media/thermostat.551fd4c2.svg";